import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Form from '../../../../../vendor/react-validation/components/form';
import Button from '../../../../../vendor/react-validation/components/button';

import TextInput from './TextInput';

import getFormValues from '../../../../Forms/getFormValues';
import {validEmail, mustBeEqual, validSwedishPhoneNumber, blankOrPassesValidation } from '../../../../Forms/Validation/rules';
import { replaceSwedishCountryCodeWithZero, sanitizeNumber } from '../../../../Forms/Validation/helpers';
import definitions from '../../../../Style/LfStyleDefinitions';

import {mediaQuery} from '../../../../Style/cssHelpers';

export default class EmailForm extends React.Component {

    static propTypes = {
        modifierClass: PropTypes.array,
        email: PropTypes.string,
        phone: PropTypes.string,
        mobile: PropTypes.string,
        onFormCancel: PropTypes.func,
        onFormSubmit: PropTypes.func,
    }

    static defaultProps = {
        modifierClass: [],
        email: '',
        phone: '',
        mobile: '',
        onFormCancel: () => {},
        onFormSubmit: () => {}
    };


    submitForm = (e) => {
        e.preventDefault();
        const formValues = getFormValues(this.form);

        formValues.mobilePhone = sanitizeNumber(
            replaceSwedishCountryCodeWithZero(formValues.mobilePhone)
        );

        if (formValues.emailAddress == '' && formValues.emailAddressConfirmation == '') {
            delete formValues.emailAddress;
            delete formValues.emailAddressConfirmation;
        }

        this.props.onFormSubmit(formValues);
    }

    render() {
        const currentEmail = this.props.email
            ? this.props.email
            : 'mail@mail.se';

        return (
            <Form ref={el => { this.form = el; }} onSubmit={e => this.submitForm(e)}>
                <FormRow noBorder>
                    <Heading>Mobiltelefon</Heading>
                    <TextInput
                        id="mobilePhone"
                        name="mobilePhone"
                        value={this.props.mobile}
                        data-validation-error-message="Ange ett svenskt telefonnummer"
                        validations={[
                            validSwedishPhoneNumber,
                        ]}
                    />
                </FormRow>
                <FormRow noBorder>
                    <Heading>E-postadress</Heading>
                    <TextInput
                        id="emailAddress"
                        name="emailAddress"
                        placeholder={currentEmail}
                        data-validation-error-message="Ange en korrekt e-post"
                        validations={[
                            blankOrPassesValidation(validEmail),
                            mustBeEqual('emailAddress', 'emailAddressConfirmation')
                        ]}
                    />
                </FormRow>
                <FormRow noBorder>
                    <Heading>Bekräfta e-postadress</Heading>
                    <TextInput
                        id="emailAddressConfirmation"
                        name="emailAddressConfirmation"
                        placeholder={currentEmail}
                        data-validation-error-message="Ange en korrekt e-mailadress"
                        validations={[
                            blankOrPassesValidation(validEmail),
                            mustBeEqual('emailAddress', 'emailAddressConfirmation', 'E-postadresserna stämmer inte överens')
                        ]}
                    />

                    <Button className="my-pages-btn button button--green">
                        Spara
                    </Button>
                    <CancelButton className="my-pages-btn--cancel" onClick={(ev) => { ev.preventDefault(); this.props.onFormCancel(); }}>
                        Avbryt
                    </CancelButton>
                </FormRow>
            </Form>
        );
    }
}


// styles
export const FormRow = styled.div`
    position: relative;

    button {
        margin-top: 10px;
    }
    button[disabled] {
        opacity: 0.5;
    }
`;

export const Heading = styled.h5`
    font-size: 24px;
    ${mediaQuery.small(`
        font-size: 18px !important;
        line-height: 37.4px;
    `)}
    margin-bottom: 5px !important;
`;
export const CancelButton = styled.button`
    font-weight: normal !important;
`;